import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2NotebookIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 23.267 23.387",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 23.387),
    children: [/*#__PURE__*/jsx("path", {
      d: "M7.968 22.39H3a2.12 2.12 0 01-2.1-2.1M18.093 8.828V1.664A.753.753 0 0017.329.9H3.766A2.814 2.814 0 00.9 3.766V20.29a2.12 2.12 0 012.1-2.1h5.732"
    }), /*#__PURE__*/jsx("path", {
      d: "M21.723 14.464l-7.259 7.261-3.63.764.764-3.63 7.259-7.259a2.077 2.077 0 012.866 0 1.914 1.914 0 010 2.864z"
    })]
  });
};

export { PM2NotebookIcon };
//# sourceMappingURL=notebook.js.map
